import styled from "styled-components";
import variables from "../../theme/variables";
export const HomeContainer = styled.div`
  height: 100%;
  padding-top: 80px !important;
  display: flex;
  .menu {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    ul {
      margin: 0;
      list-style: none;
      font-size: 22px;
      font-weight: bold;
      width: 100%;
      li {
        cursor: pointer;
      }
    }
    .separator {
      position: absolute;
      right: 10%;
      width: 2px;
      height: 100%;
      overflow: hidden;
    }
    svg {
      mask-image: linear-gradient(to bottom, transparent 0, #000 280px);
      -webkit-mask-image: linear-gradient(to bottom, transparent 0, #000 280px);
    }
    svg line {
      stroke: #fff;
      stroke-width: 2;
      transition: all 0.8s cubic-bezier(0.645, 0.045, 0.355, 1);
      -webkit-transition: all 0.8s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
    .logo-video {
      width: 360px;
    }
    .logo-gif {
      display: none;
    }
  }
  .content {
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
    &::-webkit-scrollbar {
      display: none;
    }
    .page {
      overflow-y: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
      height: 100%;
      width: 100%;
      position: absolute;
      left: ${({ showingPage }) => (showingPage ? "0" : "-100%")};
      transition: all 0.3s;
      padding-bottom: 32px;
      .page-view {
        .back {
          svg {
            cursor: pointer;
            font-size: 32px;
          }
        }
      }
    }
    .posts {
      overflow-y: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
      height: 100%;
      left: ${({ showingPage }) => (showingPage ? "100%" : "0")};
      position: absolute;
      width: 100%;
      transition: all 0.3s;
      .posts-title {
        width: 100%;
        position: sticky;
        top: 0;
        background-color: ${variables.colors.background};
        z-index: 10;
        span {
          display: block;
          padding: 8px 0;
          font-size: 22px;
          font-weight: 300;
          max-width: 360px;
          line-height: 26px;
        }
      }
      .categories {
        display: flex;
        padding-bottom: 8px;
        .title {
          padding-top: 2px;
          padding-right: 8px;
        }
        .category {
          border-radius: 5px;
          padding: 0px 4px 4px 4px;
          cursor: pointer;
          margin: 2px 4px;
          line-height: 15px;
          min-height: 18px;
          &:first-child {
            margin-left: 0;
          }
        }
        .selected {
          background: #565656;
          cursor: default;
        }
      }
      .masonry {
        columns: 2;
        column-gap: 1rem;
      }
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  @media (max-width: 1024px) {
    .content {
      .posts {
        .masonry {
          columns: 1;
          column-gap: 1rem;
        }
      }
    }
  }
  @media (max-width: 768px) {
    padding-top: 0 !important;
    flex-wrap: wrap;
    .menu {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      position: sticky;
      top: 0;
      z-index: 99;
      background: ${variables.colors.background};
      ul {
        font-size: 14px;
        font-weight: 400;
        padding: 0;
        li {
          display: inline;
          padding-left: 8px;
        }
      }
      .separator {
        display: none;
      }
      .logo-video,
      .logo-gif {
        width: 48px;
        padding: 4px 0;
      }
      @supports (-webkit-touch-callout: none) {
        .logo-video {
          display: none;
        }
        .logo-gif {
          display: block;
        }
      }
    }
    .content {
      padding-top: 16px;
      .posts-title {
        display: none;
      }
    }
  }
`;
